import $ from 'jquery';
/**
 * This expects the following layout:
 * <div id="carousel">
 *     <div class="carousel-item"></div>
 *     <div class="carousel-item"></div>
 *     <div class="carousel-item"></div>
 * </div>
 * where the #carousel has position: relative and .carousel-item has position absolute; top:0; left:0;
 * This will build the controls and send events to the container.
 * @require jQuery (built with 1.10.2)
 */
(function (global, $) {

    function Carousel ( opts ) {

        var defaults = {
            containerId        : 'carousel', // contains the whole carousel
            itemClass          : 'carousel-item', // each image slide will have this class
            controlClass       : 'carousel-control', // each control will have this class
            controlContainerId : 'carouselcontrols', // all the controls will be held in this
            activeClass        : 'active', // this class is applied both to the slides and controls
            eventString        : 'carousel', // the string to use for the carousel update custom event
            delay              : 6000 // delay between carousel slide updating itself
        };

        this.options = $.extend( defaults, opts );

        this.$container = $('#' + this.options.containerId);
        this.createControls();

        // special left/right controls
        //this.createLeftRightControls();

        this.fading();         // set up transitions effect
        this.updateControls(); // set up listeners for the controls
        this.firstItem();      // sets the first visible item
        this.startTicker();
    }

    Carousel.prototype.createLeftRightControls = function () {
        var lrId = 'leftrightcontrols',
            leftId = 'carouselleft',
            rightId = 'carouselright';

        if (this.$container.children('.' + this.options.itemClass).length < 2) {
            return; // dont' create the controls for only one item
        }

        // create a container for the left / right controls
        this.$container.append( $('<div/>', {id: lrId}) );
        // Add the controls to the control container
        $('#' + lrId).append( $('<div/>', {id:leftId}) ).append( $('<div/>', {id: rightId}) );
    };

    /**
     * This is called during the setup phase, creating controls a control
     * for each of the slides.
     */
    Carousel.prototype.createControls = function() {

        var that = this;

        this.$items = this.$container.children( '.' + this.options.itemClass );
        this.$controls = $('<div/>', {id: this.options.controlContainerId}).appendTo( this.$container );

        // Create the controls
        this.$items.each(function (index, el) {
            that.addControl.call( that );
        });

        // add event handlers for the controls
        this.setControlListeners( this.$controls.children('.' + this.options.controlClass) );
    };

    /**
     * @usedby createControls()
     */
    Carousel.prototype.addControl = function () {
        this.$controls.append( $('<div/>', {'class': this.options.controlClass}) );
    };

    /**
     * Triggers the first slide (a part of setup). This function should be called
     * after the listeners have been setup to listen for the carousel update event,
     * as it triggers that event itself.
     */
    Carousel.prototype.firstItem = function () {
        this.$items.first().addClass( this.options.activeClass );

        this.$container.trigger(this.options.eventString, {index: 0});
    };

    /**
     * @param {object<jQuery>} $controls
     */
    Carousel.prototype.setControlListeners = function ( $controls ) {

        var that = this,
            index;

        $controls.on('click.carousel', function (event) {
            index = $(this).index();
            that.$items
                .not(':eq(' + index + ')').removeClass( that.options.activeClass )
                .end().eq( index ).addClass( that.options.activeClass );

            that.$container.trigger(that.options.eventString, {index: index});
            that.stopTicker();
        });

    };

    /**
     * this listens for the 'carousel' event and fades out inactive slides,
     * fading in the active one.
     */
    Carousel.prototype.fading = function () {
        var that = this;

        this.$container.on(this.options.eventString, function (event, data) {
            that.$items
                .not( '.' + that.options.activeClass ).fadeOut().end()
                .filter( '.' + that.options.activeClass ).fadeIn();
        });
    };

    /**
     * Listens for the 'carousel' event and uses its index data to set
     * the relevant control to the 'active' state.
     */
    Carousel.prototype.updateControls = function () {
        var that = this;

        this.$container.on(this.options.eventString, function (event, data) {
            that.$controls.children()
                .not( ':eq(' + data.index + ')' ).removeClass( that.options.activeClass ).end()
                .eq( data.index ).addClass( that.options.activeClass );
        });
    };

    /**
     * @uses tick()
     */
    Carousel.prototype.startTicker = function () {

        var that = this;

        this.ticker = setInterval(function () {
            that.tick.call( that );
        }, this.options.delay);

    };

    Carousel.prototype.stopTicker = function () {
        clearInterval( this.ticker );
    };

    /**
     * @usedby startTicker()
     * this function triggered regularly by a setInterval. This should
     * tick the carousel onto the next slide, or wrap when it gets to the end.
     */
    Carousel.prototype.tick = function () {

        var length = this.$items.length,
            currIndex = this.$items.filter('.' + this.options.activeClass).index(),
            newIndex, // the index of the slide to transition to
            $new;

        if (length <= currIndex + 1) {
            // wrap to the start
            newIndex = 0;
        } else {
            // go to the next item
            newIndex = currIndex + 1;
        }

        this.$items
            .not( $new = this.$items.eq(newIndex) ).removeClass( this.options.activeClass );

        $new.addClass( this.options.activeClass );

        this.$container.trigger(this.options.eventString, {index: newIndex});
    };

    // kick things off here
    $(function () {
        new Carousel();
    });

}(window, $));
